import React from 'react';
import { tp } from 'app/utils/typograf';
import css from './maslenitsaDetails.module.scss';
import '../../dishDetailsWithCustom.scss';


const MaslenitsaSetDescription = () => (
    <div className={css.maslenitsaSetList}>
        <div className={css.mainCard}>
            <div className={css.maslenitsaDescription}>
                {tp.execute('С 6 по 19 февраля добавьте набор в свой заказ и получите возможность выиграть сковороду от Tefal.')}
            </div>
            <div className={css.maslenitsaDescription}>
                {tp.execute('На блинной сковороде Tefal Unlimited каждый блин всегда супер за счет равномерного нагрева всей поверхности и антипригарного покрытия. А индикатор температуры подскажет, когда сковорода будет готова. Подходит для всех типов плит. Сделана во Франции.')}
            </div>
            <div className={css.maslenitsaDescription}>
                {tp.execute('Каждый день в 15 рандомных заказов с этим набором вкладываем сковороду от Tefal.')}
            </div>
            <div className={css.maslenitsaDescription}>
                {tp.execute('В наборе всё, что устроить настоящий пир — легко и быстро:')}
            </div>
            <div className={`${css.cardContent} ${css.cardContentMobile}`}>
                <ul className={css.cardContentList}>
                    <li>
                        {tp.execute('1,5 кг уже готового домашнего теста, чтобы испечь целую стопку идеальных блинчиков.')}
                    </li>
                    <li>
                        {tp.execute('5 начинок (2 солёных и 3 сладких): солёная карамель, ягодное варенье, облепиховое повидло, мясная начинка, намазка из горбуши по-царски - всё готовим сами, и сметана - классика неизменная.')}
                    </li>
                </ul>
            </div>
        </div>
    </div>
);

export const MaslenitsaDetails = () => (
    <div className={css.maslenitsaDetailsRoot}>
        <div className={css.maslenitsaSetList}>
            <MaslenitsaSetDescription />
        </div>
    </div>
);
